  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
  import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import TextField                                           from '@material-ui/core/TextField';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
  import Link                                                from '@material-ui/core/Link';
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
  import MuiAlert                                            from '@material-ui/lab/Alert';
  //[FAB]
  import Fab                                                 from '@material-ui/core/Fab';
  import CallIcon                                            from '@material-ui/icons/Call';
  //[PASSWORDTYPE]
  import InputAdornment                                      from '@material-ui/core/InputAdornment';
  import IconButton                                          from '@material-ui/core/IconButton';
  import Visibility                                          from '@material-ui/icons/Visibility';
  import VisibilityOff                                       from '@material-ui/icons/VisibilityOff';
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //----------
  // Libraries
  //----------
  import Cookies                                             from 'js-cookie';
  //recaptcha_V2
  import ReCAPTCHA                                           from "react-google-invisible-recaptcha";
  //recaptcha_V3
//import useRecaptchaV3                                      from "components/useRecaptchaV3/useRecaptchaV3.jsx";
  import { GoogleReCaptchaProvider, GoogleReCaptcha }        from 'react-google-recaptcha-v3';
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_LoginLogoutService }                           from "../../_services";
  import { wu_ProfileService }                               from "../../_services";
  import { wu_RegisterLightService }                         from "../../_services";
  import { wu_AppVersion }                                   from "../../_services";
  import { wu_CountriesStatesCitiesService }                 from "../../_services";
//import { wu_TransactionFlow }                              from "../../_services";
//import { wu_OnlineMTService }                              from "../../_services";
  import { wu_GeolocationService }                           from "../../_services";
//import { wu_AppVersion }                                   from "../../_services";
  //------
  // Style
  //------
  import loginPageStyle                                      from "./loginPageStyle.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";

  import gotoAppiOS                                          from "assets/img/wu/gotoAppiOS.png";
  import gotoAppAndroid                                      from "assets/img/wu/gotoAppAndroid.png";
  //[Campaign]
  import WU_popup_campaign_el                                from "assets/img/wu/popup_campaign_el.png";
  import WU_popup_campaign_en                                from "assets/img/wu/popup_campaign_en.png";
  //----------
  // variables
  //----------
  const filename = "LoginPage ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  //[Lockers]
  var LoginPage_continue_locked = true;

  //const REACT_VERSION = React.version;

class LoginPage extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+JSON.stringify(props));}

    let prefill_userName_after_changePass = "";
    try{ prefill_userName_after_changePass = localStorage.getItem("prefill_userName_after_changePass");}catch(err){console.log(methName+'err='+err);}
    if(api.print_logs){console.log(methName+"prefill_userName_after_changePass="+prefill_userName_after_changePass);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      viewPleaseWait_hidden                                : true,

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",

      //[HONEYMOON]
      textField0                                           : "", //4279034659
      textField0_hasError                                  : false,

      //[RECAPTCHA]
      recaptchaVersionSupported                            : "V3", //"V2", "V3", "NONE"
      //recaptcha_V3
      refreshReCaptchaV3                                   : false,

      cardAnimaton                                         : "cardHidden",
      loginEmail                                           : prefill_userName_after_changePass,
      loginEmail_initial_value                             : prefill_userName_after_changePass,
      loginEmail_hasError                                  : false,
      loginPassword                                        : "",
      loginPassword_hasError                               : false,

      dialog2_msg                                          : "",
      dialog2_isOpen                                       : false,

      dialog3_msg                                          : "",
      dialog3_isOpen                                       : false,

      passwordType1                                        : "password",

      //[FAB]
      fab_isHidden                                         : true,
      dialog100_msg                                        : "",
      dialog100_isOpen                                     : false,

      //[Campaign]
      dialog101_msg                                        : "",
      dialog101_isOpen                                     : false,
      dialog101_campaign_image_w                           : "512",
      dialog101_campaign_image_h                           : "268",
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                            = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                           = this.dialog_handleClose.bind(this);
    this.startSpinners                                                = this.startSpinners.bind(this);
    this.stopSpinners                                                 = this.stopSpinners.bind(this);

    //[Lockers]
    this.isLockersActive                                              = this.isLockersActive.bind(this);
    this.startLockers                                                 = this.startLockers.bind(this);
    this.stopLockers                                                  = this.stopLockers.bind(this);

    this.handleSubmit_with_enter                                      = this.handleSubmit_with_enter.bind(this);
    this.handleSubmit                                                 = this.handleSubmit.bind(this);
    this.handleSubmit_isDisabled                                      = this.handleSubmit_isDisabled.bind(this);
    this.handleSubmit_with_recaptcha                                  = this.handleSubmit_with_recaptcha.bind(this);
    this.recaptchaRef_login                                           = React.createRef();

    this.dialog2_handleClose                                          = this.dialog2_handleClose.bind(this);
    this.dialog2_handleResendEmail                                    = this.dialog2_handleResendEmail.bind(this);
    this.dialog2_handleResendEmail_isDisabled                         = this.dialog2_handleResendEmail_isDisabled.bind(this);
    //recaptcha_V2
    this.dialog2_handleResendEmail_with_recaptcha                     = this.dialog2_handleResendEmail_with_recaptcha.bind(this);
    this.recaptchaRef_resend                                          = React.createRef();
    //recaptcha_V3
    this.dialog2_handleResendEmail_get_recaptchaV3_token              = this.dialog2_handleResendEmail_get_recaptchaV3_token.bind(this);
    this.reset_recaptchaV3_token                                      = this.reset_recaptchaV3_token.bind(this);

    this.dialog3_handleClose                                          = this.dialog3_handleClose.bind(this);
    this.dialog3_gotoProfile                                          = this.dialog3_gotoProfile.bind(this);

    this.get_PasswordType1                                           = this.get_PasswordType1.bind(this);
    this.handlePopoverOpen_passwordType1                             = this.handlePopoverOpen_passwordType1.bind(this);

    //[SNACKBAR]
    this.Snackbar_textField_handleOpen                                = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                               = this.Snackbar_textField_handleClose.bind(this);

    //[FAB]
    this.fab_geoLocateIP                                              = this.fab_geoLocateIP.bind(this);
    this.fab_Click2CallAction                                         = this.fab_Click2CallAction.bind(this);
    this.dialog100_handleOpen                                         = this.dialog100_handleOpen.bind(this);
    this.dialog100_handleClose                                        = this.dialog100_handleClose.bind(this);

    //[CAMPAIGN]
    this.dialog101_handleOpen                                         = this.dialog101_handleOpen.bind(this);
    this.dialog101_handleClose                                        = this.dialog101_handleClose.bind(this);

    this.handleClick_gotoAppAndroid                                   = this.handleClick_gotoAppAndroid.bind(this);
    this.handleClick_gotoAppiOS                                       = this.handleClick_gotoAppiOS.bind(this);

    if(localStorage.getItem("lang")!=='el' && localStorage.getItem("lang")!=='en'){ localStorage.setItem("lang","el"); Cookies.set('wp-wpml_current_language', "el");} console.log("lang="+localStorage.getItem("lang"));
    localStorage.setItem("UserSelectedCountry", "GR");
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);
    console.log(Cookies.get('curr_view',{secure:false,expires:1,path:api.webapp_path}));
    Cookies.set('curr_view', filename.trim());

    console.log(methName+"REACT_VERSION="+React.version);

    //[Lockers]
    this.stopLockers();

    wu_Utilities.LogoutUserFromApp(filename);

    //-------------
    //Do some reset
    //-------------
    try { localStorage.setItem("parserObject_omtregistrationTriggerOTP_req", ""); } catch(err){;}
    this.clear_cardpayment_transfer_cookies();
    this.clear_cardpayment_bill_cookies();
    //--------------------
    //global variables set
    //--------------------
    try { localStorage.setItem("newRegistrationFlow",""); } catch(err){;}
    try { localStorage.setItem("parserObject_transhistorydetail_unique",""); } catch(err){;}
    try { localStorage.setItem("RegisterLight1".trim(), "");  } catch(err){;}
    localStorage.setItem("FLOW_confirm_register_after", api.FLOW_confirm_register_after_login_simple);
    //------------
    //getCountries---CACHED
    //------------
    let retrieveWSData_getCountries = wu_CountriesStatesCitiesService.wu_should_getCountries();
    if(retrieveWSData_getCountries){
      wu_CountriesStatesCitiesService
      .wu_getCountries({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="LoginPage"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        var parserObject_getCountries4Picker = [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({ "parserObject_getCountries"        : res.countries });
        this.setState({ "parserObject_getCountries4Picker" : parserObject_getCountries4Picker });
      })
      .catch(err => {
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        console.log(methName+"err="+JSON.stringify(err));
        let res = wu_StaticDataService.wu_get_cached_countries({});
        var parserObject_getCountries4Picker= [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker,
        });
      });
    }
    else{
      try{
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        let res = JSON.parse(localStorage.getItem("countries"));
        var parserObject_getCountries4Picker= [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({ "parserObject_getCountries"        : res.countries });
        this.setState({ "parserObject_getCountries4Picker" : parserObject_getCountries4Picker });
      }catch(err){
        console.log('err='+err);
      }
    }

    //[FAB]
    this.fab_geoLocateIP();

    //[CAMPAIGN]
    //wu_Utilities.campaign_clear_statsView(api.campaign_enabled,api.campaign_prefix,api.campaign_cap_per_session,filename.trim());
    wu_Utilities.campaign_record_load(api.campaign_enabled,api.campaign_prefix,api.campaign_cap_per_session,api.campaign_startDate,api.campaign_endDate,filename.trim());
    if(wu_Utilities.campaign_should_show(api.campaign_enabled,api.campaign_prefix,api.campaign_cap_per_session,api.campaign_startDate,api.campaign_endDate,filename.trim())===true){
      console.log("campaigns window.innerWidth="+window.innerWidth);
      if(window.innerWidth > 960){ this.setState({"dialog101_campaign_image_w":"512","dialog101_campaign_image_h":"268",}); }
      else                       { this.setState({"dialog101_campaign_image_w":"256","dialog101_campaign_image_h":"134",}); }
      this.dialog101_handleOpen("");
    }

    //nailed for testing:START---inactive
    //Cookies.set('country', 'CANADA');
    //Cookies.set('amount',  '10');
    //nailed for testing:END
  }
  //----------------------------------------------------------------------------------------------------
  //[FAB]
  fab_geoLocateIP(){
    let methName = "fab_geoLocateIP";
    //SOS TODO cache for a certain period
    if(localStorage.getItem("IPCOUNTRY")!==""){ this.setState({ "fab_isHidden":false }); return; }
    //-------------------
    //wu_getPhonePrefixes---STATIC
    //-------------------
    let phonePrefixes = wu_StaticDataService.wu_getPhonePrefixes({});
    //--------------
    //wu_geolocation
    //--------------
    wu_GeolocationService
    .wu_geolocation({}) //FAB
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="LoginPage"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      localStorage.setItem("parserObject_geolocation",JSON.stringify(res.location));
      let ws_country = "";
      try {ws_country = res.location["country"]; }catch(err){;} if(ws_country === null || (typeof ws_country ==="undefined")){ws_country = "";}
      for(let i=0; i<phonePrefixes.phone_prefixes.length; ++i){
        if(phonePrefixes.phone_prefixes[i]["descr"].indexOf(ws_country)>=0){
          localStorage.setItem("IPCOUNTRY",           phonePrefixes.phone_prefixes[i]["ctry_wu_id"]);
          localStorage.setItem("UserSelectedCountry", phonePrefixes.phone_prefixes[i]["ctry_wu_id"]);
          break;
        }
      }
      //console.log(methName+"IPCOUNTRY="+localStorage.getItem("IPCOUNTRY"));
      if(localStorage.getItem("IPCOUNTRY")!==""){this.setState({ "fab_isHidden":false });}
    })
    .catch(err => {
      console.log(methName+"err="+err);
    });
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}

    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );

    //----------------------
    //Criteo Event Recording
    //----------------------
    let shouldUseCriteo = api.shouldUseCriteo;
    if(shouldUseCriteo===true && api.webappENV==="PROD"){
      try {
        window.criteo_q = window.criteo_q || [];
        var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
        window.criteo_q.push(
         { event: "setAccount", account: api.criteo_account }, // You should never update this line
         { event: "setEmail", email: "" },                  // Can be an empty string
         { event: "setSiteType", type: deviceType},
         { event: "trackTransaction", id: Math.floor(Math.random()*99999999999)+1, item: [{id:"1", price:1, quantity:1}] }
        );
      }catch(err0){console.log(methName+"err0="+err0);}
    }
    //-----------
    //recaptchaV3
    //-----------
    var recaptchaTokenV3 = localStorage.getItem("recaptchaTokenV3");
    //console.log(methName+"recaptchaTokenV3="+recaptchaTokenV3);
    if(recaptchaTokenV3===null || recaptchaTokenV3===""){
      setTimeout(function() { this.reset_recaptchaV3_token("init"); }.bind(this), 500);
    }
    this.reset_recaptchaV3_token_TIMER();
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    const { classes }  = this.props;
  //const { loggedIn } = this.props;
  //const { logginIn } = this.props;
  //const { alert }    = this.props;

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          {/* [FAB] */}
          {this.state.fab_isHidden === true ? ( "" ) : (
            <Fab color="primary" aria-label="add" onClick={this.fab_Click2CallAction} className={classes.fab}>
              <CallIcon />
            </Fab>
          )}
          <GridItem xs={12} sm={6} md={6}>

            <div style={{ marginTop: 25 }}>
              <div className={classes.labelHeader}>{this.NSInforString("HomePage_lbl_hello")}</div>
              <div className={classes.labelSubHeader}>{this.NSInforString("HomePage_lbl_signInToYourAccount")}</div>
              <div className={classes.logo}><img src={logo} alt="logo" /></div>
            </div>

            <GridContainer justify="center">

                {/* ------------------------- */}
                {/* ----------[HONEYMOON]---- */}
                {/* ------------------------- */}
                <GridItem xs={12} sm={12} md={12} className={classes.GridItemTextField0}>
                    <TextField
                      fullWidth
                      autoComplete="off"
                      error={this.state.textField0_hasError}
                      className={classes.textField0}
                      id={this.autoCompleteText_Textfields()}
                      label={this.autoCompleteText_Textfields()}
                      value={this.state.textField0}
                      InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField0"), type: "text" }}
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.loginEmail_hasError}
                    className={classes.loginEmail}
                    id="loginEmail"
                    label={this.NSInforString("HomePage_plh_user")}
                    defaultValue={this.state.loginEmail_initial_value}
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "loginEmail"),
                      type: "email"
                    }}
                  />
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    onKeyPress={this.handleSubmit_with_enter}
                    error={this.state.loginPassword_hasError}
                    className={classes.loginPassword}
                    id="loginPassword"
                    label={this.NSInforString("HomePage_plh_pass")}
                    defaultValue=""
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "loginPassword"),
                      type: this.get_PasswordType1(),
                      endAdornment:
                        <InputAdornment position="end">
                          <IconButton onClick={this.handlePopoverOpen_passwordType1}  style={{padding:0}}> {this.get_PasswordType1()==="text" ? <VisibilityOff /> : <Visibility />}</IconButton>
                        </InputAdornment>
                    }}
                  />
                </GridItem>
                {/* ------------------------- */}
                {/* ----------[SPINNERS]----- */}
                {/* ------------------------- */}
                {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
                  <GridContainer justify="center">
                    <GridItem xs={3} sm={3} md={3}></GridItem>
                    <GridItem xs={6} sm={6} md={6}>
                      <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                    </GridItem>
                    <GridItem xs={3} sm={3} md={3}></GridItem>
                  </GridContainer>
                )}
                {/* ------------------------- */}
                {/* ----------[BUTTONS]------ */}
                {/* ------------------------- */}
                {api.isCaptchaEnabled_LoginPage_login === true ? (
                  <GridItem xs={10} sm={10} md={10}>
                    <div className={classes.textCenter}>
                      <ReCAPTCHA
                        ref={ ref => this.recaptchaRef_login = ref }
                        locale={localStorage.getItem("lang")}
                        sitekey={api.captchKey}
                        onResolved={ this.handleSubmit } />
                      <CustomButton
                        disabled={this.handleSubmit_isDisabled()}
                        className={classes.yellowButton}
                        color="rose"
                        onClick={this.handleSubmit_with_recaptcha}
                        type="submit">
                        {this.NSInforString("HomePage_btn_login")}
                      </CustomButton>
                    </div>
                  </GridItem>
                ) : (
                  <GridItem xs={10} sm={10} md={10}>
                    <div className={classes.textCenter}>
                      <CustomButton
                        disabled={this.handleSubmit_isDisabled()}
                        className={classes.yellowButton}
                        color="rose"
                        onClick={this.handleSubmit}
                        type="submit">
                        {this.NSInforString("HomePage_btn_login")}
                      </CustomButton>
                    </div>
                  </GridItem>
                )}

                <GridItem xs={12} sm={12} md={12}>
                  <div className={classes.dontHaveAccount}>{this.NSInforString("HomePage_lbl_dontHaveAccount")}</div>
                </GridItem>

                <GridContainer justify="center">
                  <GridItem xs={5} sm={5} md={3} style={{justifyContent:"center", display:"flex"}}>
                    <NavLink
                      to={api.new_registration_enabled ? wu_Utilities.getNavigationURLs("RegisterLight1") : wu_Utilities.getNavigationURLs("RegisterLight1")}
                      activeStyle={{ color:'teal'}}
                      justify="center">
                      {this.NSInforString("HomePage_lbl_registerHere")}
                    </NavLink>
                  </GridItem>
                </GridContainer>

                <div className={classes.labelHeader}>&nbsp;</div>
                <div className={classes.labelHeader}>&nbsp;</div>

                <GridContainer justify="center">
                  <GridItem xs={6} sm={6} md={4} style={{justifyContent:"center", display:"flex"}}>
                    <NavLink
                      to={wu_Utilities.getNavigationURLs("ForgotPass1")}
                      activeStyle={{ color:'teal'}}
                      justify="center">
                      {this.NSInforString("HomePage_btn_forgotAccount")}
                    </NavLink>
                  </GridItem>
                </GridContainer>

                <div className={classes.labelHeader}>&nbsp;</div>
                <div className={classes.labelHeader}>&nbsp;</div>

                <GridContainer justify="center">
                  <GridItem xs={6} sm={6} md={4} style={{justifyContent:"center", display:"flex"}}>
                    <div className={classes.downloadApp}>{this.NSInforString("HomePage_lbl_downloadApp")}</div>
                  </GridItem>
                </GridContainer>

                <GridContainer justify="center" >
                  <GridItem xs={12} sm={5} md={3} style={{justifyContent:"center", display:"flex", marginBottom:"5px"}}>
                      <Link style={{ cursor: 'pointer' }} onClick={(event) => this.handleClick_gotoAppiOS(event)}><img width={124} height={42} align="center" src={gotoAppiOS} alt=""/></Link>
                  </GridItem>
                  <GridItem xs={12} sm={5} md={3} style={{justifyContent:"center", display:"flex"}}>
                      <Link style={{ cursor: 'pointer' }} onClick={(event) => this.handleClick_gotoAppAndroid(event)}><img width={124} height={42} align="center" src={gotoAppAndroid} alt=""/></Link>
                  </GridItem>
                </GridContainer>

                <div className={classes.labelHeader}>&nbsp;</div>
                <div className={classes.labelHeader}>&nbsp;</div>

              </GridContainer>

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[SNACKBAR]----- */}
        {/* ------------------------- */}
        <Snackbar open={this.state.Snackbar_textField_open} autoHideDuration={api.snackBarDurationMS} onClose={this.Snackbar_textField_handleClose}>
          <Alert onClose={this.Snackbar_textField_handleClose} severity="error">{this.state.Snackbar_textField_msg}</Alert>
        </Snackbar>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* -------------------------------------------------- */}
        {/* ----------[POPUP RESEND CONFIRMATION EMAIL]------- */}
        {/* -------------------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog2_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog2_handleClose}
            aria-labelledby="alert-dialog2-slide-title"
            aria-describedby="alert-dialog2-slide-description"
          >
            <DialogTitle id="alert-dialog2-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog2-slide-description">{this.state.dialog2_msg}</DialogContentText>
            </DialogContent>
            {/* -----------recaptcha_V2 -------------- */}
            {/* {api.isCaptchaEnabled_LoginPage_resend === true ? (
              <DialogActions>
                <ReCAPTCHA
                  ref={ ref => this.recaptchaRef_resend = ref }
                  locale={localStorage.getItem("lang")}
                  sitekey={api.captchKey}
                  onResolved={ this.dialog2_handleResendEmail } />
                <Button className={classes.popupOkButton} color="default" onClick={this.dialog2_handleResendEmail_with_recaptcha}>{this.NSInforString("alert_RESEND_CONFIRMATION_SMS")}</Button>
                <Button className={classes.popupOkButton} color="default" onClick={this.dialog2_handleClose}>{this.NSInforString("alert_CANCEL")}</Button>
              </DialogActions>
            ) : (
              <DialogActions>
                <Button className={classes.popupOkButton} color="default" onClick={this.dialog2_handleResendEmail}>{this.NSInforString("alert_RESEND_CONFIRMATION_SMS")}</Button>
                <Button className={classes.popupOkButton} color="default" onClick={this.dialog2_handleClose}>{this.NSInforString("alert_CANCEL")}</Button>
              </DialogActions>
            )} */}
            {/* -----------recaptcha_V3 -------------- */}
            {api.isCaptchaEnabled_LoginPage_resend === true ? (
              <DialogActions>
                <GoogleReCaptchaProvider reCaptchaKey={api.captchKeyV3}>
                  <GoogleReCaptcha
                      className="google-recaptcha-custom-class"
                      onVerify={this.dialog2_handleResendEmail_get_recaptchaV3_token}
                      refreshReCaptcha={this.state.refreshReCaptchaV3}
                  />
                </GoogleReCaptchaProvider>
                <Button className={classes.popupOkButton} color="default" onClick={this.dialog2_handleResendEmail}>{this.NSInforString("alert_RESEND_CONFIRMATION_SMS")}</Button>
                <Button className={classes.popupOkButton} color="default" onClick={this.dialog2_handleClose}>{this.NSInforString("alert_CANCEL")}</Button>
              </DialogActions>
            ) : (
              <DialogActions>
                <Button className={classes.popupOkButton} color="default" onClick={this.dialog2_handleResendEmail}>{this.NSInforString("alert_RESEND_CONFIRMATION_SMS")}</Button>
                <Button className={classes.popupOkButton} color="default" onClick={this.dialog2_handleClose}>{this.NSInforString("alert_CANCEL")}</Button>
              </DialogActions>
            )}
          </Dialog>
        </div>
        {/* -------------------------------------------------- */}
        {/* ----------[POPUP GOTO SETTINGS]------------------- */}
        {/* -------------------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog3_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog3_handleClose}
            aria-labelledby="alert-dialog3-slide-title"
            aria-describedby="alert-dialog3-slide-description"
          >
            <DialogTitle id="alert-dialog3-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog3-slide-description">{this.state.dialog3_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog3_gotoProfile}>{this.NSInforString("alert_GO_TO_PROFILE")}</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ------------------------- */}
        {/* ----------[POPUP][FAB]--- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog100_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog100_handleClose}
            aria-labelledby="alert-dialog100-slide-title"
            aria-describedby="alert-dialog100-slide-description"
          >
            <DialogTitle id="alert-dialog100-slide-title">{api.popup_tile}</DialogTitle>
            {localStorage.getItem("lang")==="en" ? (
              <DialogContent>Need assistance?<br/>We are at your disposal!<br/>Call us at<br/><b><a href="tel://2109005000">210 900 5000</a></b><br/>or<br/><b><a href="tel://8001002020">800 100 2020</a></b><br/>(toll free from a landline)<br/><br/>Call Center operating hours:<br/>Monday to Sunday 08:00 με 21:00</DialogContent>
            ) : (
              <DialogContent>Χρειάζεσαι βοήθεια;<br/>Είμαστε στη διάθεσή σου!<br/>Κάλεσε μας στο<br/><b><a href="tel://2109005000">210 900 5000</a></b><br/>ή στο<br/><b><a href="tel://8001002020">800 100 2020</a></b><br/>(χωρίς χρέωση από σταθερό)<br/><br/>Ωράριο τηλεφωνικής εξυπηρέτησης:<br/>Δευτέρα με Κυριακή 08:00 με 21:00</DialogContent>
            )}
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog100_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ------------------------------ */}
        {/* ----------[POPUP][CAMPAIGN]--- */}
        {/* ------------------------------ */}
        <div>
          <Dialog
            open={this.state.dialog101_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog101_handleClose}
            aria-labelledby="alert-dialog101-slide-title"
            aria-describedby="alert-dialog101-slide-description"
          >
            <DialogTitle id="alert-dialog101-slide-title">{api.popup_tile}</DialogTitle>
            {localStorage.getItem("lang")==="el" ? (
              <DialogContent><img src={WU_popup_campaign_el} alt=""  width={this.state.dialog101_campaign_image_w} height={this.state.dialog101_campaign_image_h}/></DialogContent>
            ) : (
              <DialogContent><img src={WU_popup_campaign_en} alt=""  width={this.state.dialog101_campaign_image_w} height={this.state.dialog101_campaign_image_h}/></DialogContent>
            )}
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog101_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------recaptcha_V3--------------------------------------
  //----------------------------------------------------------------------------------------------------
  //recaptcha_V3
  reset_recaptchaV3_token_TIMER = function() {
      var self = this;
      this.timer = setInterval(function() {
          self.reset_recaptchaV3_token("init");
      }, 90000)
  }
  //----------------------------------------------------------------------------------------------------
  reset_recaptchaV3_token(status) {
    let methName = filename+"reset_recaptchaV3_token ";
    //if(api.print_logs){console.log(methName);}

    if(this.state.recaptchaVersionSupported==="V3"){
      if(status==="init")   { this.setState({"refreshReCaptchaV3" : !this.state.refreshReCaptchaV3 }); this.generateRecaptchaV3(status); return; }
      if(status==="success"){ localStorage.setItem("recaptchaTokenV3", ""); /*this.setState({"refreshReCaptchaV3" : !this.state.refreshReCaptchaV3 }); this.generateRecaptchaV3();*/ return; }
      if(status==="failure"){ this.setState({"refreshReCaptchaV3" : !this.state.refreshReCaptchaV3 }); this.generateRecaptchaV3(status); return; }
      if(api.print_logs){console.log(methName+"this.state.refreshReCaptchaV3="+this.state.refreshReCaptchaV3);}
    }
  }
  //----------------------------------------------------------------------------------------------------
  generateRecaptchaV3(status) {
    let methName = filename+"generateRecaptchaV3 ";
    //if(api.print_logs){console.log(methName);}

    window.grecaptcha.execute(api.captchKeyV3, {action: "YOUR_ACTION_NAME"}).then(function(token) {
      if (token) {
        if(api.print_logs){console.log(methName+"status="+status+" token= "+token);}
        localStorage.setItem("recaptchaTokenV3", token);
      }
    });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  handleSubmit_isDisabled(){
    if(this.isLockersActive()===true){ return true; }
    return false;
  }
  handleSubmit_with_enter(event){
    if (event.charCode === 13) { // enter key pressed
      event.preventDefault();
      this.handleSubmit(event);
      // do something here
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleSubmit_with_recaptcha(event) {
    let methName = filename+"handleSubmit_with_recaptcha ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = (this.state.recaptchaVersionSupported==="V2") ? true : false; //true;//api.isCaptchaEnabled;

    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.loginEmail.trim()    === "") { this.setState({"loginEmail_hasError"    : true }); emptyFields = true; }
      if(this.state.loginPassword.trim() === "") { this.setState({"loginPassword_hasError" : true }); emptyFields = true; }
      if(emptyFields===true){if(shouldResetCaptcha){this.recaptchaRef_login.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    if(this.verifyGenericItem("email",this.state.loginEmail)===false){
      this.dialog_handleOpen(this.NSInforString("email_validation"));
      if(shouldResetCaptcha){this.recaptchaRef_login.reset();}
      return;
    }
    if(this.verifyLength(this.state.loginEmail,1)===false){
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+" "+this.NSInforString("HomePage_plh_user"));
      if(shouldResetCaptcha){this.recaptchaRef_login.reset();}
      return;
    }
    if(this.verifyLength(this.state.loginPassword,1)===false){
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+" "+this.NSInforString("HomePage_plh_pass"));
      if(shouldResetCaptcha){this.recaptchaRef_login.reset();}
      return;
    }
    let loginPassword_hasGreekChar = false;
    let loginPassword              = this.state.loginPassword;
    for(let i=0; loginPassword.length>0 && i<loginPassword.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(loginPassword[i])===true){ loginPassword_hasGreekChar=true; break; } }
    if(loginPassword_hasGreekChar===true){
      this.dialog_handleOpen(this.NSInforString("common.field.latin_no_greek"));
      if(shouldResetCaptcha){this.recaptchaRef_login.reset();}
      return;
    }
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef_login.reset();}
      return;
    }
    //++++++++
    //Continue
    //++++++++
    event.preventDefault();
    if(this.handleSubmit_isDisabled()){ console.log(methName+"reset");  this.recaptchaRef_login.reset();   }
    else                              { console.log(methName+"execute");this.recaptchaRef_login.execute(); }
  }
  //----------------------------------------------------------------------------------------------------
  handleSubmit(event) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName);}

    //[Lockers]
    if( this.isLockersActive() ){ return; }
    else                        { this.startLockers(); }

    let shouldResetCaptcha = (this.state.recaptchaVersionSupported==="V2") ? true : false; //true;//api.isCaptchaEnabled;

    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.loginEmail.trim()    === "") { this.setState({"loginEmail_hasError"    : true }); emptyFields = true; }
      if(this.state.loginPassword.trim() === "") { this.setState({"loginPassword_hasError" : true }); emptyFields = true; }
      if(emptyFields===true){this.stopLockers();if(shouldResetCaptcha){this.recaptchaRef_login.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    if(this.verifyGenericItem("email",this.state.loginEmail)===false){
      this.dialog_handleOpen(this.NSInforString("email_validation"));
      if(shouldResetCaptcha){this.recaptchaRef_login.reset();}
      this.stopLockers(); return;
    }
    if(this.verifyLength(this.state.loginEmail,1)===false){
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+" "+this.NSInforString("HomePage_plh_user"));
      if(shouldResetCaptcha){this.recaptchaRef_login.reset();}
      this.stopLockers(); return;
    }
    if(this.verifyLength(this.state.loginPassword,1)===false){
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+" "+this.NSInforString("HomePage_plh_pass"));
      if(shouldResetCaptcha){this.recaptchaRef_login.reset();}
      this.stopLockers(); return;
    }
    let loginPassword_hasGreekChar = false;
    let loginPassword              = this.state.loginPassword;
    for(let i=0; loginPassword.length>0 && i<loginPassword.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(loginPassword[i])===true){ loginPassword_hasGreekChar=true; break; } }
    if(loginPassword_hasGreekChar===true){
      this.dialog_handleOpen(this.NSInforString("common.field.latin_no_greek"));
      if(shouldResetCaptcha){this.recaptchaRef_login.reset();}
      this.stopLockers(); return;
    }
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef_login.reset();}
      this.stopLockers(); return;
    }
    //++++++++
    //Continue
    //++++++++
    localStorage.setItem("HTTP_user",this.state.loginEmail);
    localStorage.setItem("prefill_userName_after_changePass", "");

    //event.preventDefault();
    this.startSpinners();
    setTimeout(function() { //Start the timer
      //--------
      //wu_login
      //--------
      wu_LoginLogoutService
      .wu_login({username:this.state.loginEmail,password:this.state.loginPassword})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="LoginPage"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        if(shouldResetCaptcha){this.recaptchaRef_login.reset();}
        Cookies.set('isLoggedInAtWebApp', 'true', { expires:1, path:'' });
        wu_Utilities.registration_telephone_set("");
        wu_Utilities.update_uilatstats();
        //-------------------
        //wu_validatecustomer
        //-------------------
        wu_ProfileService
        .wu_validatecustomer({})
        .then(res => {
          if(localStorage.getItem("curr_view").trim()!=="LoginPage"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
          //this.stopLockers();this.stopSpinners();
          localStorage.setItem("parserObject_validatecustomer",JSON.stringify(res.customer));

          this.stopLockers();this.stopSpinners();
          let parserObject_validatecustomer = {};
          try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
          var pendingDataConfirmation  = 0;
          var hasCompletedRegistration = "";
          try {pendingDataConfirmation  = parserObject_validatecustomer["pendingDataConfirmation"];  }catch(err){;} if(pendingDataConfirmation  === null){pendingDataConfirmation  = 0; }
          try {hasCompletedRegistration = parserObject_validatecustomer["hasCompletedRegistration"]; }catch(err){;} if(hasCompletedRegistration === null){hasCompletedRegistration = "";}
          //nailed for testing:START---inactive
          //hasCompletedRegistration="1";
          //nailed for testing:END

          //---------------------
          //newCustomer filtering---After Login
          //---------------------
          if(api.new_registration_enabled){
            localStorage.setItem("LoginPage_flow",          "true");
            localStorage.setItem("TransferOnlineLogin_flow","false");
            var newRegistrationFlow = wu_Utilities.newRegistrationFlow_flag_get(api.print_logs,parserObject_validatecustomer);
            if(api.print_logs){console.log(methName+"newRegistrationFlow screen=" + newRegistrationFlow["screen"]);}
            try { localStorage.setItem("newRegistrationFlow",newRegistrationFlow["flow"]); } catch(err){;}
            if(newRegistrationFlow["screen"]==="CustomerConfirm"){ history.push(wu_Utilities.getNavigationURLs("CustomerConfirm"));   }
            if(newRegistrationFlow["screen"]==="TransferOnline1"){ history.push(wu_Utilities.getNavigationURLs("TransferOnline1"));   }
            if(newRegistrationFlow["screen"]==="Bills")          { history.push(wu_Utilities.getNavigationURLs("Bills"));             }
            if(newRegistrationFlow["screen"]==="RegisterInfo")   { history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); }
            return;
          }
        })
        .catch(err => { //wu_validatecustomer
          if(shouldResetCaptcha){this.recaptchaRef_login.reset();}
          this.stopLockers();this.stopSpinners();
          console.log(methName+"err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);/*history.push(wu_Utilities.getNavigationURLs("LoginPage"));*/} this.dialog_handleOpen(err.returnText); }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
        });
      })
      .catch(err => { //wu_login
        if(shouldResetCaptcha){this.recaptchaRef_login.reset();}
        this.stopLockers();this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){
          //nailed for testing:START---inactive
          //err.returnCode=4;
          //nailed for testing:END
          if(err.returnCode===4 ){ wu_Utilities.registration_telephone_set(err.data.phone); this.dialog2_handleOpen(err.returnText); }
          else                   { this.dialog_handleOpen(err.returnText);  }
        }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
      });
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    //if(api.print_logs){console.log(stateVar+" "+eventTMP);}

    if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
      this.setState({"textField0":eventTMP.trim(),});
    }
    else if(stateVar==="loginEmail"){
      this.setState({
        "loginEmail"          : eventTMP,
        "loginEmail_hasError" : (eventTMP.trim() === "") ? true : false,
      });
    }
    else if(stateVar==="loginPassword"){
      this.setState({
        "loginPassword"          : eventTMP,
        "loginPassword_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      for(let i=0; eventTMP.length>0 && i<eventTMP.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(eventTMP[i])===true){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin_no_greek")); this.setState({"loginPassword_hasError":true}); return; } }
    }
    else{
      this.setState({ [stateVar] : eventTMP });
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {
    if(key==="email"){ return wu_Utilities.wu_verifyEmail(val); }

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg){
    this.setState({ "dialog_isOpen" : true });
    this.setState({ "dialog_msg"    : dialog_msg });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups2--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog2_handleOpen(dialog2_msg){
    this.setState({ "dialog2_isOpen" : true });
    this.setState({ "dialog2_msg"    : dialog2_msg });
  }
  dialog2_handleClose(){
    this.setState({ "dialog2_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  dialog2_handleResendEmail_isDisabled(){
    if(this.isLockersActive()===true){ return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  dialog2_handleResendEmail_with_recaptcha(event) {
    let methName = filename+"dialog2_handleResendEmail_with_recaptcha ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = (this.state.recaptchaVersionSupported==="V2") ? true : false; //true;//api.isCaptchaEnabled;

    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef_resend.reset();}this.reset_recaptchaV3_token("validation");
      return;
    }
    //++++++++
    //Continue
    //++++++++
    event.preventDefault();
    if(this.dialog2_handleResendEmail_isDisabled()){ console.log(methName+"reset");  this.recaptchaRef_resend.reset();   }
    else                                           { console.log(methName+"execute");this.recaptchaRef_resend.execute(); }
  }
  //----------------------------------------------------------------------------------------------------
  //recaptcha_V3
  dialog2_handleResendEmail_get_recaptchaV3_token(token) {
    let methName = filename+"dialog2_handleResendEmail_get_recaptchaV3_token ";
    //if(api.print_logs){console.log(methName);}

    if (token && token.length>300) {
      if(api.print_logs){console.log(methName+new Date()+" token=" +token);}
      localStorage.setItem("recaptchaTokenV3", token);
    }
  }
  //----------------------------------------------------------------------------------------------------
  dialog2_handleResendEmail(){
    let methName = filename+"dialog2_handleResendEmail ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = (this.state.recaptchaVersionSupported==="V2") ? true : false; //true;//api.isCaptchaEnabled;

    //+++++++++++
    //[RECAPTCHA]
    //+++++++++++
    var recaptchaVerify = "";
    //recaptcha_V2
    if(this.state.recaptchaVersionSupported==="V2"){
      recaptchaVerify = shouldResetCaptcha ? JSON.stringify(this.recaptchaRef_resend.getResponse()) : "";
      if(api.print_logs){console.log(methName+"recaptchaVerify="+recaptchaVerify);}
    }
    //recaptcha_V3
    if(this.state.recaptchaVersionSupported==="V3"){
      recaptchaVerify = localStorage.getItem("recaptchaTokenV3");
      if(api.print_logs){console.log(methName+"recaptchaVerify="+recaptchaVerify);}
    }

    this.setState({ "dialog2_isOpen": false });

    let parserObject_checkAppVersion_req = {};
    parserObject_checkAppVersion_req["platform"]   = api.platform;
    parserObject_checkAppVersion_req["appVersion"] = api.appVersion;

    var parserObject_omtRegistrationResendOTP_req = {};
    parserObject_omtRegistrationResendOTP_req["email"]           = new Buffer(this.state.loginEmail.trim()).toString('base64');
    parserObject_omtRegistrationResendOTP_req["telephone"]       = wu_Utilities.registration_telephone_get();;
    parserObject_omtRegistrationResendOTP_req["isMobile"]        = "1";
    parserObject_omtRegistrationResendOTP_req["recaptchaVerify"] = recaptchaVerify;
    //---------------
    //checkAppVersion
    //---------------
    wu_AppVersion
    .wu_checkAppVersion(parserObject_checkAppVersion_req)
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="LoginPage"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      //if(shouldResetCaptcha){this.recaptchaRef_resend.reset();}this.reset_recaptchaV3_token("success");
      //this.stopSpinners();
      parserObject_omtRegistrationResendOTP_req["val1"] = res.val1;

      //---------------------------
      //wu_omtRegistrationResendOTP
      //---------------------------
      wu_RegisterLightService
      .wu_omtRegistrationResendOTP(parserObject_omtRegistrationResendOTP_req)
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="LoginPage"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        if(shouldResetCaptcha){this.recaptchaRef_resend.reset();}this.reset_recaptchaV3_token("success");
        this.stopSpinners();

        localStorage.setItem("parserObject_omtRegistrationResendOTP_req", JSON.stringify(parserObject_omtRegistrationResendOTP_req));
        //+++++++++++++++++
        //RegisterLight1OTP
        //+++++++++++++++++
        history.push(wu_Utilities.getNavigationURLs("RegisterLight1OTP"));
      })
      .catch(err => {
        this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
      });
    })
    .catch(err => { //wu_checkAppVersion
      if(shouldResetCaptcha){this.recaptchaRef_resend.reset();}this.reset_recaptchaV3_token("failure");
      this.stopSpinners();
      console.log(methName+"err="+JSON.stringify(err));
      if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText,"NET"); }
      else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
    });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups3--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog3_handleOpen(dialog3_msg){
    this.setState({ "dialog3_isOpen" : true });
    this.setState({ "dialog3_msg"    : dialog3_msg });
  }
  dialog3_handleClose(){
    this.setState({ "dialog3_isOpen": false });
  }
  dialog3_gotoProfile(){
    localStorage.setItem("LoginPage_flow",          "true");
    localStorage.setItem("TransferOnlineLogin_flow","false");
    //++++++++++++++++
    //SettingsProfile1
    //++++++++++++++++
    history.push(wu_Utilities.getNavigationURLs("SettingsProfile1"));
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  get_PasswordType1(){
    return this.state.passwordType1;
  }
  handlePopoverOpen_passwordType1(){
    if(this.state.passwordType1==="password"){this.setState({ "passwordType1" : "text", });}
    if(this.state.passwordType1==="text")    {this.setState({ "passwordType1" : "password", });}
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[Lockers]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  isLockersActive(){
    if( LoginPage_continue_locked===true ){ return true;  }
    else                                  { return false; }
    //if( localStorage.getItem(filename.trim()+"_continue_locked")==="true" ){ /*console.log("isLockersActive===true");*/  return true;  }
    //else                                                                   { /*console.log("isLockersActive===false");*/ return false; }
  }
  //----------------------------------------------------------------------------------------------------
  startLockers(){
    LoginPage_continue_locked = true;
    //localStorage.setItem(filename.trim()+"_continue_locked","true");
  }
  //----------------------------------------------------------------------------------------------------
  stopLockers(){
    LoginPage_continue_locked = false;
    //localStorage.setItem(filename.trim()+"_continue_locked","false");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[FAB]---------------------------------------------
  //----------------------------------------------------------------------------------------------------
  fab_Click2CallAction(){
    if(localStorage.getItem("IPCOUNTRY")!==""){ this.dialog100_handleOpen(""); }
    else                                      { window.open(api.helpdeskURL, "Live Support", "toolbar=0,status=0,width=548,height=325"); }
  }
  dialog100_handleOpen(dialog_msg){
    this.setState({ "dialog100_isOpen" : true });
    this.setState({ "dialog100_msg"    : dialog_msg });
  }
  dialog100_handleClose(){
    this.setState({ "dialog100_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[CAMPAIGN]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog101_handleOpen(dialog_msg){
    this.setState({ "dialog101_isOpen" : true });
    this.setState({ "dialog101_msg"    : dialog_msg });
  }
  dialog101_handleClose(){
    this.setState({ "dialog101_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[COOKIES]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  clear_cardpayment_transfer_cookies(){
    let methName = filename+"clear_cardpayment_transfer_cookies ";
    if(api.print_logs){console.log(methName);}
    try{
    //try{ Cookies.remove('platform',                              { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('lang',                                  { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('isLoggedIn',                            { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('accessToken',                           { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('centralID',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_PaymentMethod',         { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_TransferMethod',        { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_selCountry_ctry_wu_id', { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('gross',                                 { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('normalCharges',                         { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('expectedActualPayout',                  { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_curr',                              { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('principal',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_fname',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_lname',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}

    //try{ Cookies.remove('platform',                              { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('lang',                                  { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('isLoggedIn',                            { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('accessToken',                           { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('centralID',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_PaymentMethod',         { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_TransferMethod',        { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_selCountry_ctry_wu_id', { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('gross',                                 { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('normalCharges',                         { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('expectedActualPayout',                  { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_curr',                              { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('principal',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_fname',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_lname',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
  clear_cardpayment_bill_cookies(){
    let methName = filename+"clear_cardpayment_bill_cookies ";
    if(api.print_logs){console.log(methName);}
    try{
      try{ Cookies.remove('accessToken',                           { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('transId',                               { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('billId',                                { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}

      try{ Cookies.remove('accessToken',                           { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('transId',                               { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('billId',                                { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Autocomplete--------------------------------------
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_autoCompleteDropDown(){
    return filename+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_Textfields(){
    //return filename+Math.random().toString().replace(/0\./g,"");
    //return filename.replace(/ /g,"")+Math.random().toString().replace(/0\./g,"");
    return Math.random().toString().replace(/0\./g,"")+"LP1"+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  handleClick_gotoAppAndroid(event){
    let methName = filename+"handleClick_gotoAppAndroid ";
    console.log(methName);

    event.preventDefault();
    //window.location.href = "https://play.google.com/store/apps/details?id=com.paylink.westernunion";
    window.open("https://play.google.com/store/apps/details?id=com.paylink.westernunion", "_blank");
  }
  //----------------------------------------------------------------------------------------------------
  handleClick_gotoAppiOS(event){
    let methName = filename+"handleClick_gotoAppiOS ";
    console.log(methName);

    event.preventDefault();
    //window.location.href = "https://apps.apple.com/gr/app/western-union-paylink/id1185869802";
    window.open("https://apps.apple.com/gr/app/western-union-paylink/id1185869802", "_blank");
  }
  //----------------------------------------------------------------------------------------------------
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
//const { loggedIn } = state.authentication;
//const { logginIn } = state.authentication;
//const { alert } = state;
  const { dispatch } = state;
  return {
    dispatch,
  //loggedIn,
  //logginIn,
  //alert
  };
}
export default connect(mapStateToProps)(
  withStyles(loginPageStyle)(LoginPage)
);
